import { useSeo } from '@/hooks/useSeo';
import { siteConfig } from '@/mocks/site';
import { faqs } from '@/mocks/faqs';
import { articles } from '@/mocks/articles';
import HeroSection from './components/HeroSection';
import HotRanking from './components/HotRanking';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import TrackingSection from './components/TrackingSection';
import VoicesSection from './components/VoicesSection';
import FaqPreview from './components/FaqPreview';
import SubscribeCta from './components/SubscribeCta';

export default function Home() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: siteConfig.name,
      url: 'https://dyfscl.cn/',
      description: siteConfig.description,
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://dyfscl.cn/category/entertainment?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteConfig.name,
      url: 'https://dyfscl.cn/',
      email: siteConfig.email,
      description: '聚焦未公开信息与内部消息的中文资讯平台，提供独家首发与第一手线索整理。',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.slice(0, 4).map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: '最新爆料',
      itemListElement: articles.slice(0, 6).map((a, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        url: `https://dyfscl.cn/article/${a.id}`,
        name: a.title,
      })),
    },
  ];

  useSeo({
    title: '17爆料网 - 独家首发·内部消息·知情人士第一手料',
    description: siteConfig.description,
    keywords: '17爆料网,17爆料网独家,17爆料网首发,17爆料网内部消息,17爆料网知情人士,17爆料网第一手料',
    path: '/',
    jsonLd,
  });

  return (
    <>
      <HeroSection />
      <HotRanking />
      <TrackingSection />
      <CategoryGrid />
      <LatestArticles />
      <VoicesSection />
      <FaqPreview />
      <SubscribeCta />
    </>
  );
}